module.exports = __webpack_public_path__ + "static/media/life-bertuo.de3ac099.jpg";